import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=72dd7316"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports